import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { SharedModule } from '@shared/shared.module'
import { MapRolesComponent } from '@app/features/scoping/components/map-roles/map-roles.component'
import { RatecardVersion } from '@app/features/scope-overview/model/ratecard-version.model'

export interface LibraryEntriesDuplicateMapRatecardsModalConfig {
  sourceRateCard: RatecardVersion
  targetRateCard: RatecardVersion
  mappingRoles: any[]
  targetRoles: any[]
  onSubmit: (mapping: Record<string, string | null>) => any
}

@Component({
  standalone: true,
  templateUrl: './library-entries-duplicate-map-ratecards-modal.component.html',
  styleUrls: ['./library-entries-duplicate-map-ratecards-modal.component.scss'],
  imports: [SharedModule, MapRolesComponent],
})
export class LibraryEntriesDuplicateMapRatecardsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<LibraryEntriesDuplicateMapRatecardsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LibraryEntriesDuplicateMapRatecardsModalConfig
  ) {}

  onCancel() {
    this.dialogRef.close()
  }

  onConfirm() {
    const mapping = this.data.mappingRoles.reduce(
      (acc, role) => {
        acc[role.id] = role.targetMappingRole?.id ?? null
        return acc
      },
      {} as Record<string, string | null>
    )
    this.data.onSubmit(mapping)
    this.dialogRef.close()
  }
}
